import WebLayout from './EventTransactionPartiesLayout.web';
import MobileLayout from './EventTransactionPartiesLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
